import React from "react";

import Slide from "@material-ui/core/Slide";

import ImagenAuth from "components/ImagenAuth/ImagenAuth.js";

// Piezas compartidas por las pestanas del modulo (Autorizar.js, IntentosTab.js e
// IntentoDetalle.js): transicion de los modales, chips, validacion de coordenadas,
// renglones del detalle, galeria de fotos protegidas por JWT y textos de ReactTable.
// Todo sin estado: helpers puros con el mismo estilo inline de la vista.

export const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// chip de estatus de la solicitud: naranja PENDIENTE / verde AUTORIZADA / rojo RECHAZADA
export const chipColoresEstatus = {
    "PENDIENTE": { fondo: "#fff3e0", texto: "#e65100", borde: "#ffb74d" },
    "AUTORIZADA": { fondo: "#e8f5e9", texto: "#2e7d32", borde: "#81c784" },
    "RECHAZADA": { fondo: "#ffebee", texto: "#c62828", borde: "#e57373" },
};

// chip del estado de una entrega EAD (E/D/L)
export const chipColoresEntrega = {
    "E": chipColoresEstatus["AUTORIZADA"],
    "D": chipColoresEstatus["RECHAZADA"],
    "L": { fondo: "#e3f2fd", texto: "#1565c0", borde: "#64b5f6" },
};

// chip discreto del tipo de solicitud: REVERSIÓN (revierte una entrega de hoy)
// vs DIRECTA (guía pendiente, sin entrega previa)
export const chipColoresTipo = {
    "REVERSION": { fondo: "#eceff1", texto: "#455a64", borde: "#b0bec5" },
    "DIRECTA": { fondo: "#e3f2fd", texto: "#1565c0", borde: "#64b5f6" },
};

export function chip(texto, colores) {
    const vColores = colores || { fondo: "#eeeeee", texto: "#616161", borde: "#bdbdbd" };
    return (
        <span style={{
            display: "inline-block",
            padding: "3px 10px",
            borderRadius: 12,
            fontSize: 11,
            fontWeight: 600,
            whiteSpace: "nowrap",
            backgroundColor: vColores.fondo,
            color: vColores.texto,
            border: "1px solid " + vColores.borde,
        }}>
            {texto}
        </span>
    );
}

export const chipEstatus = (estatus) => chip(estatus, chipColoresEstatus[estatus]);
export const chipEntrega = (estado, estadoTexto) => chip(estadoTexto || "—", chipColoresEntrega[estado]);
// tipo ausente (fila vieja o API sin el campo) se trata como REVERSION, el default de la columna
export const chipTipo = (tipo) => chip(tipo === "DIRECTA" ? "DIRECTA" : "REVERSIÓN", chipColoresTipo[tipo] || chipColoresTipo["REVERSION"]);

// chip del numero de intento de entrega: ambar "1 de 2" (el chofer aun puede reintentar)
// / rojo "2 de 2" (tope alcanzado: entregar o devolver en almacen)
export const chipIntento = (numero, maximo) => {
    const vNumero = parseInt(numero, 10) || 0;
    const vMaximo = parseInt(maximo, 10) || 2;
    return chip(vNumero + " de " + vMaximo, vNumero >= vMaximo ? chipColoresEstatus["RECHAZADA"] : chipColoresEstatus["PENDIENTE"]);
};

// coordenadas validas: numericas y distintas de (0,0); si no, no se pinta marker
export function coordenadasValidas(lat, lon) {
    const vLat = parseFloat(lat);
    const vLon = parseFloat(lon);
    if (isNaN(vLat) || isNaN(vLon)) { return null; }
    if (vLat === 0 && vLon === 0) { return null; }
    return { lat: vLat, lng: vLon };
}

export const renglonDato = (etiqueta, valor) => (
    <p style={{ margin: "3px 0" }}>
        <strong>{etiqueta}:</strong>{" "}{(valor === null || valor === undefined || valor === "") ? "—" : valor}
    </p>
);

// galeria de fotos protegidas por JWT: rutaBase + n (n desde 1) via ImagenAuth
export const galeria = (rutaBase, total, alt) => {
    const imagenes = [];
    const n = parseInt(total, 10) || 0;
    for (let i = 1; i <= n; i++) {
        imagenes.push(<ImagenAuth key={rutaBase + i} src={rutaBase + i} alt={alt + " " + i} />);
    }
    if (imagenes.length === 0) {
        return <p style={{ color: "#9e9e9e", margin: "3px 0" }}>Sin fotos</p>;
    }
    return <div>{imagenes}</div>;
};

export const textosTabla = {
    previousText: 'Anterior',
    nextText: 'Siguiente',
    loadingText: 'Cargando...',
    noDataText: 'No se encontro ningun registro',
    pageText: 'Pagina',
    ofText: 'de',
    rowsText: 'Filas',
};
